export const STEP_IDS = {
  SELECT_PRODUCTS: 'select-products',
  CONFIRM_TRANSFER: 'confirm-transfer',
} as const;
